import { hobbiesList } from "../static/Hobbies"

interface IHobbiesGenerator {
  data: string[]
}
export const HobbiesGenerator = ({ data }: IHobbiesGenerator): string[] => {
  const userNativeHobbies: string[] = []

  data.forEach((hobbyName) => {
    for (const group of hobbiesList) {
      const item = group.items.find((item) => item.name === hobbyName)
      if (item) {
        userNativeHobbies.push(item.native_name)
        break
      }
    }
  })
  return userNativeHobbies
}
